import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SEND_LOGIN_OTP, GENERATE_LOGIN_OTP_SUCCESS } from '../../redux/constant';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import OTPInput from '../../component/OTP';
import './OtpInput.scss'

const OtpInput = ({ onBack }) => {
  const [otp, setOtp] = useState('');
  const { restaurant, id, table } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirectTo = useSelector(state => state.user?.redirectTo || state.redirectTo);

const formatGuid = (value) => {
  if (!value) return null;
  const cleaned = decodeURIComponent(String(value))
    .trim()
    .replace(/^[{"]|[}"]$/g, "");

  // Convert 32-char GUID without hyphens into 36-char hyphenated GUID
  if (/^[0-9a-fA-F]{32}$/.test(cleaned)) {
    return `${cleaned.slice(0, 8)}-${cleaned.slice(8, 12)}-${cleaned.slice(12, 16)}-${cleaned.slice(16, 20)}-${cleaned.slice(20)}`;
  }

  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(cleaned) ? cleaned : null;
};

  // Todo: Remove below useEffect
  // Teporary - skip OTP verification for testing purposes
  useEffect(() => {

    dispatch({ type: SEND_LOGIN_OTP, payload: {
      phoneNumber: localStorage.getItem("user_mobile"),
      otp: '5555', // hardcoded OTP for testing purposes
      qRScan: {
        restaurantOrBranchId: id,
        tableNumber: parseInt(table) || 0,
        tableOtp: ''
      }
    } })
    // navigate(`/${restaurant}/${id}/${table}/register`);
    // navigate(`/${restaurant}/${id}/${table}/menu`);
  }, []);

  useEffect(() => {
    if (!redirectTo) return;

    if (redirectTo === "REGISTER") {
      navigate(`/${restaurant}/${id}/${table}/register`);
    } else if (redirectTo === "MENU") {
      navigate(`/${restaurant}/${id}/${table}/menu`);
    }
    dispatch({ type: "CLEAR_REDIRECT" });
  }, [redirectTo]);

  const handleLogin = () => {
    // const otpValue = otp.join('');
    const otpValue = otp;
    const loginOtp = localStorage.getItem("login-otp");

    if (otpValue !== loginOtp) {
      toast.error('Please enter a valid OTP.');
      return;
    }

    const request = {
      phoneNumber: localStorage.getItem("user_mobile"),
      otp: otpValue,
      qRScan: {
        restaurantOrBranchId: id,
        tableNumber: table,
        tableOtp: ''
      }
    };

    dispatch({ type: SEND_LOGIN_OTP, payload: request });
  };

  const handleBack = () => {
    // 1. Reset Redux OTP state
    dispatch({ type: GENERATE_LOGIN_OTP_SUCCESS, payload: null });
    // 2. Call parent callback if provided
    if (onBack) {
      onBack();
    }
  };

  return (
    <>
      <div>
        <p className='otpbtn' onClick={handleBack}> ← OTP Verification</p>
      </div>

      <p>We have sent the verification code via SMS.</p>
      <br />

      <OTPInput
        value={otp}
        onChange={setOtp}
        onComplete={() => document.getElementById('btn-login')?.focus()}
        idPrefix="login-otp"
        inputClassName="loginInput otp"
      />
      <button id='btn-login' onClick={handleLogin} className='full-btn btn'>Log in</button>
    </>
  );
};

export default OtpInput;